import {
  BiddingApprovalState,
  BiddingBidSendErrorCategory,
} from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'

/**
 * 送る直前の再検証の違反で送らずに下書きに戻した札か (AC-BIN-059、 AC-BSP-117)。 backend は
 * 戻した下書きに、 止めた送信の原因分類を返す (送信したことの無い下書きには返さない)。
 * 時間前・スポット・ブロックの一覧が、 「下書き」 のバッジに理由の tooltip を添えるかをこれで決める。
 */
export const isDraftWithSendErrorReason = (row: {
  approvalState: BiddingApprovalState | undefined
  sendErrorCategory?: BiddingBidSendErrorCategory | undefined
}): boolean =>
  row.approvalState === BiddingApprovalState.DRAFT &&
  row.sendErrorCategory !== undefined &&
  row.sendErrorCategory !== BiddingBidSendErrorCategory.UNSPECIFIED
